import { makeStyles, Theme } from '@material-ui/core/styles';

export const useStyles = makeStyles((theme: Theme) => ({
  root: {
    display: 'flex',
  },
  paper: {
    // paddingTop: theme.spacing(),
    // padding: theme.spacing(3),
    minWidth: '80%',
    maxWidth: '822px',
    maxHeight: '90%',
    overflowY: 'auto',
  },
  topBar: {
    backgroundColor: '#F6F6F6',
    padding: '20px 24px',
  },
  modal: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
  },
  title: {
    fontSize: 14,
    fontWeight: 600,
    lineHeight: '133.4%',
    color: '#363473',
  },
  text: {
    width: '100%',
    margin: '10px 0',
    backgroundColor: theme.palette.background.paper,
    fontSize: 14,
    color: '#757493;',
  },
  subtext: {
    width: '100%',
    backgroundColor: theme.palette.background.paper,
    fontSize: 12,
    color: '#757493',
  },
  marginLeft: {
    marginLeft: 32,
  },
  subTitleText: {
    backgroundColor: theme.palette.background.paper,
    fontSize: 13,
    color: '#757493',
  },
  input: {
    minWidth: 250,
    flexGrow: 1,
    fontSize: 16,
    color: 'rgb(0 0 0 / 87%)',
    '& .MuiInputBase-input.Mui-disabled': {
      color: 'rgb(0 0 0 / 87%)',
    },
  },
  row: {
    alignItems: 'center',
    justifyContent: 'flex-start',
    marginBottom: theme.spacing(2),
    flexBasis: '45%',
    flexWrap: 'wrap',
    '@media (max-width: 1399px)': {
      flexBasis: '100%',
    },
  },
  block: {
    display: 'flex',
    justifyContent: 'space-between',
    width: '100%',
  },
  container: {},
  flexBetween: {
    display: 'flex',
    width: '100%',
    justifyContent: 'space-between',
    marginBottom: 10,
  },
  flexBox: {
    display: 'flex',
    width: '100%',
  },
  flexCenter: {
    display: 'flex',
    width: '100%',
    marginTop: '30px',
    justifyContent: 'center',
    alignItems: 'flex-start',
  },
  flex: {
    display: 'flex',
    width: '100%',
    alignItems: 'center',
  },
  flexEnd: {
    display: 'flex',
    width: '100%',
    justifyContent: 'flex-end',
    marginBottom: '20px',
  },
  leftBox: {
    width: '50%',
    padding: '32px',
  },
  content: {
    width: 'calc(100% - 30px)',
  },
  checkIcon: {
    color: 'green',
    marginRight: 5,
  },
  rightBox: {
    width: '50%',
    padding: '32px',
  },
  card: {
    width: '100%',
    padding: '24px 19px',
    backgroundColor: 'white',
    border: '1px solid #ECECFF',
    borderRadius: '16px',
  },
  icon: {
    width: '30px',
    height: '30px',
    borderRadius: '50%',
    backgroundColor: '#007DFF',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    color: 'white',
    marginRight: '15px',
  },
  profileContainer: {
    marginRight: 32,
    width: 192,
  },
  profileImgContainer: {
    marginRight: 10,
  },
  profileImg: {
    width: 200,
    borderRadius: '50%',
  },
  formContainer: {
    marginRight: 32,
    flex: 1,
  },
  heading: {
    fontSize: 18,
    fontWeight: 'bold',
    marginBottom: 25,
    color: '#363473',
  },
  backIcon: {
    fontSize: 16,
    marginRight: 12,
  },
  red: {
    color: '#E2222B',
  },
  green: {
    color: '#64C968',
  },
  closeIcon: {
    padding: 0,
    minWidth: 'auto',
  },
  divider: {
    border: 0,
    height: 1,
    backgroundColor: '#E0E0E0',
    margin: '24px 0',
  },
  btn: {
    height: 48,
    backgroundColor: '#E2222B',
  },
  link: {
    textDecoration: 'underline',
    color: '#363473',
    fontWeight: 600,
    cursor: 'pointer',
  },
  batch: {
    color: '#B7C0EB',
    fontSize: 18,
    marginRight: 20,
  },
  verticalLine: {
    borderLeft: '1.5px dashed #64C968',
    margin: '5px 0',
    height: '50px',
    // position: 'absolute',
  },
}));
